define((require) => {
    "use strict";

    const Backbone              = require("backbone");
    const ImprovedModel         = require("shared/zbone/ImprovedModel");
    const PublishableCollection = require("data/PublishableCollection");
    const ContentQuery          = require("data/ContentQuery");
    const BreakpointGroup       = require("shared/ui/breakpoint/BreakpointGroup");
    const ExperienceModel       = require("shared/ui/experience/ExperienceModel");
    const LocalizationGroup     = require("shared/services/localization/LocalizationGroup");

    // Defined supported (polymorphic) types/models.
    const contentTypes = new Map();

    contentTypes.set(LocalizationGroup.type, LocalizationGroup);
    contentTypes.set(BreakpointGroup.type, BreakpointGroup);
    contentTypes.set(ExperienceModel.type, ExperienceModel);

    return {

        /**
         * Starts fetching the publishables.
         *
         * @param  {Object} options Options passed to the fetch call.
         * @return {Promise}        Promise that resolves with a <tt>Backbone.Collection</tt> containing the publishables.
         */
        fetch(options = {}) {
            const sorting = options.sorting || ContentQuery.sort().field("editedAt");
            let query = null;

            if (options.term) {
                query = ContentQuery.search(options.term, sorting);
            } else {
                query = sorting;
            }

            const publishableCollection = new PublishableCollection(options);
            return publishableCollection.query(query)
                .then((results) => {
                    const models = new Backbone.Collection(results);
                    const publishableDescriptors = this.descriptors(models);

                    return {
                        models,
                        publishableCollection,
                        publishableDescriptors
                    };
                });
        },

        descriptors(models) {
            return models.map((model) => {
                return {
                    name: model.publishableDisplayName(),
                    model
                };
            });
        },

        toReference(publishable, type) {
            if (publishable) {
                const reference = {id: publishable.id};

                reference.type = type || publishable.get("type") || publishable.constructor.type;

                return reference;
            }

            return publishable;
        },

        resolveReference(reference, resolvedReferences) {
            if (!reference || reference instanceof ImprovedModel || !resolvedReferences) {
                return reference;
            }

            const model = resolvedReferences[reference.id];

            if (model) {
                const modelClass = contentTypes.get(model.type);
                return new modelClass(model);
            }

            return model;
        }

    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/Publishables.js